<div class="container cw-flex-row">
    <div class="cw-split">
        <phscw-splitter
            [splitterDisabled]="!institutionsService.selectedInstitution"
            splitterDirection="horizontal"
            settingSplitterPosition="institutionsListHorizontalSplitterPosition"
            blockname1="institutionsList"
            blockname2="institutionsDetails"
            [routed]="routedId != 0">
            <!-- Linke Seite -->
            <phscw-institutions-list leftArea> </phscw-institutions-list>

            <!-- Rechte Seite -->
            <phscw-institutions-details [routedId]="routedId" rightArea> </phscw-institutions-details>
        </phscw-splitter>
    </div>

    <phscw-submodules-menu
        [displaySubmodules]="displaySubmoduleMenu"
        [submoduleMenu]="submoduleMenu"
        [routedSubmodule]="routedSubmodule"></phscw-submodules-menu>
</div>
